import { css } from "../../../styled-system/css";

export const styles = {
  root: (visible: boolean) =>
    css({
      isolation: "isolate",
      position: "fixed",
      zIndex: "floatingHigh",
      bottom: "0",
      left: "0",
      right: "0",
      height: "74px",
      padding: "baseUnit.mobile2",
      borderTopLeftRadius: "baseUnit.mobile4",
      borderTopRightRadius: "baseUnit.mobile4",
      background: "white",
      boxShadow: "stickyBar",
      transform: visible ? "translateY(0)" : "translateY(100%)",
      transition: "transform .4s cubic-bezier(0.4, 0, 0.2, 1), height .5s cubic-bezier(0.4, 0, 0.2, 1)",
      pointerEvents: visible ? "auto" : "none",
      desktop: {
        left: "auto",
        right: "110px",
        width: "376px",
      },
    }),
  button: () =>
    css({
      width: "100%",
    }),
};
